<mat-card>
    <mat-card-header>
        <mat-card-title-group>
            <mat-card-title>
                <h1>Ohio EPA Fee Payment Options</h1>
            </mat-card-title>
        </mat-card-title-group>
    </mat-card-header>
    <mat-card-content>
        <main id="main-content" role="main">
            <section aria-label="Pay Electronically">
                <h2>Pay Electronically</h2>
                <section aria-label="Credit Card Payment">
                    <h3>Credit Card Payment</h3>
                    <p>
                        <span class="item-bold">Master Card, VISA or Discover Credit Card:</span>
                        <br/>
                        A service fee of {{serviceFeePct}}% is added to payments 
                        made by credit card.  You will be charged for two payments, the invoice payment and a separate service fee.  When 
                        you arrive at the payment screen <em>please enter your billing name and address exactly as it appears on 
                        your credit card statement.</em>
                    </p>
                        <div class="centered-payment-section">
                            <dl class="centered-payment-dl">
                                <dt>Amount Due:</dt>
                                <dd>{{ paymentParameters!.totalAmountDue.amount | currency }}</dd>
                                <dt>Service Fee:</dt>
                                <dd>{{ paymentParameters!.totalServiceFee.amount | currency }}</dd>
                                <dt class="item-bold">Total Amount Due:</dt>
                                <dd class="item-bold">{{ amountDueWithServiceFee | currency }}</dd>
                            </dl>
                            <div class="payment-btn-spacing">
                                <button mat-flat-button id="ccPayment_btn" (click)="processPayment('CC')" aria-label="Pay with Credit Card" [disabled]="isProcessingPayment">
                                    <mat-progress-spinner *ngIf="isProcessingPayment" diameter="20" mode="indeterminate" class="progress-spinner"></mat-progress-spinner>
                                    Pay with Credit Card
                                </button>
                            </div>
                        </div>
                </section>
                <!-- hide if anon payment -->
                <ng-container *ngIf="account">
                    <section aria-label="ACH Payment">
                        <h3>ACH Payment</h3>
                        <p>
                            <span class="item-bold">Automated Clearing House (ACH):</span>
                            <br/>
                            There is no service fee for ACH payments. When you provide your bank account number and routing number, you authorize us to make a one-time
                            electronic funds transfer from your bank account to pay the invoice.  If there is a debit block on your bank account, ask your bank to allow
                            transactions with Ohio EPA before paying with ACH. When you arrive at the payment screen <em>verify the billing name and address match the
                            information for your bank account and make corrections if necessary.</em>
                        </p>
                        <div class="centered-payment-section">
                            <dl class="centered-payment-dl">
                                <dt class="item-bold">Total Amount Due:</dt>
                                <dd class="item-bold">{{ paymentParameters!.totalAmountDue.amount | currency }}</dd>
                            </dl>
                            <div class="payment-btn-spacing">
                                <button mat-flat-button id="achPayment_btn" (click)="processPayment('ACH')" aria-label="Pay with ACH (electronic check)" [disabled]="isProcessingPayment">
                                    <mat-progress-spinner *ngIf="isProcessingPayment" diameter="20" mode="indeterminate" class="progress-spinner"></mat-progress-spinner>
                                    Pay with ACH (electronic check)
                                </button>
                            </div>
                        </div>
                    </section>
                </ng-container>
                <section aria-label="Pay Later">
                    <h3>Pay Later</h3>
                    <p>
                        If you would like to use Electronic Payment, but are not ready at this time, you can return to the eBusiness Center at a later time and 
                        select "Pay Ohio EPA Fees Online". You will need the Revenue ID or Transaction ID from your invoice to make your payment.
                    </p>
                </section>
            </section>
            <hr>
            <section aria-label="Other Payment Methods">
                <h2>Other Payment Methods</h2>
                <section aria-label="Check or Money Order via US Mail">
                    <h3>Check or Money Order via US Mail</h3>
                    <p>
                        If your invoice has a bar code at the bottom you may pay by check/money order, payable to Treasurer, State of Ohio, 
                        by mailing the check/money order and the bottom portion of the invoice with the bar code to Ohio EPA, PO Box 77005, 
                        Cleveland, Ohio 44194-7005. Sending payments without a bar code on the invoice to the Cleveland location will 
                        result in a processing delay.
                    </p>
                    <p>
                        If your invoice does not have a bar code, please include a copy of the invoice with your check/money order and 
                        mail to Ohio EPA, PO Box 1049, Columbus Ohio 43215-1049. Please record the Revenue ID Number from the invoice 
                        on your check/money order.
                    </p>
                    <p>
                        All checks/money orders should be made payable to "Treasurer, State of Ohio".
                    </p>
                </section>
                <section aria-label="Paying Multiple Receivables">
                    <h3>Paying Multiple Receivables</h3>
                    <p>
                        A maximum of less than or equal to 20 payments are allowed per transaction.
                    </p>
                </section>
                <section aria-label="State Agency ISTV Payment">
                    <h3>State Agency ISTV Payment</h3>
                    <p>
                        State agencies wishing to pay an invoice by ISTV may contact Ohio EPA Fiscal Administration at 614-644-2339.
                    </p>
                </section>
            </section>
            <hr>
            <section aria-label="Help Contacts">
                <h2>Help Contacts</h2>
                <p>
                    If you need assistance making a payment, please call our Fiscal office at (614) 644-2339. If you need assistance or 
                    have questions regarding Ohio EPA's eBusiness Center please call technical support at (877) 372-2499 (1-877-EPA-BIZZ) or 
                    send an email to ebizhelpdesk&#64;epa.ohio.gov.  Hours of operation are 8:00 AM to 5:00 PM weekdays, except state holidays.
                </p>
            </section>
        </main>
    </mat-card-content>
</mat-card>

<mat-card-actions align="end" styles="width: 100%; text-align:center;">
    <button mat-flat-button id="startOver_btn" (click)="startOver()" aria-label="Exit">Exit</button>
</mat-card-actions>
